module.exports = __webpack_public_path__ + "img/horno-historia-1.80935ad3.jpg";